import { Button, FormHelperText, Stack, Typography } from '@mui/material'

import { AddMediaButton } from '../../components/MediaGallery/AddMediaButton'
import { MediaEntryType } from '../../components/MediaGallery/MediaGallery'
import {
  MultipleChoiceAnswerWithRelated,
  PromptWithRelated
} from '../../models/inspections'

export const UploadPhotoForAnswer = ({
  answer,
  prompt
}: {
  answer: MultipleChoiceAnswerWithRelated
  prompt: PromptWithRelated
}) => {
  return (
    <>
      {answer.info!.requiresPhoto && prompt.media.length === 0 && (
        <FormHelperText error>
          * Please upload a photo for this answer
        </FormHelperText>
      )}
      <Stack direction="row" spacing={1} p={1} alignItems={'center'}>
        <Button variant="contained" component="label">
          {prompt.media.length > 0 ? 'Upload More' : 'Upload Photo'}
          <AddMediaButton
            mediaEntryType={MediaEntryType.inspectionPrompt}
            parentId={answer.info!.prompt!}
            isMobileDevice={false}
          />
        </Button>
        {prompt.media.length > 0 && (
          <Typography variant="subtitle1">Photo Uploaded</Typography>
        )}
      </Stack>
    </>
  )
}
